import { useNavigate } from 'react-router-dom';
import { Stack, SIZE, Text, ELEVATION } from '@quinyx/ui';

import CustomerForm from '../../../forms/customer';
import { CUSTOMERROUTE, withCustomerLayout } from '../../../layouts/customer';
import { useCreateCustomer } from '../../../hooks/customer';
import { ICustomerBasicInfo } from '../../../api/interfaces/customer';
import { useTranslate } from '../../../hooks/translate';

const Create = () => {
  const { t } = useTranslate();
  const { createCustomer, isLoading, error } = useCreateCustomer();
  const navigate = useNavigate();

  const handleSubmit = async (customerData: ICustomerBasicInfo) => {
    const { id } = await createCustomer({ customer: customerData });
    navigate(`${CUSTOMERROUTE.IN_PROGRESS}/${id}`);
  };

  return (
    <Stack spacing={SIZE.M}>
      <Text variant="titleStandard" color="PrimaryMain">
        {t('customer.createNewCustomer')}
      </Text>

      <Stack
        spacing={SIZE.M}
        borderRadius={SIZE.L}
        p={SIZE.M}
        elevation={ELEVATION.SMOOTH}
        backgroundColor="SurfaceMain">
        <CustomerForm
          isLoading={isLoading}
          onSubmit={handleSubmit}
          error={error}
        />
      </Stack>
    </Stack>
  );
};

export default withCustomerLayout(Create);
